function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVeevaModule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 39.233 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.953 34.549A30784.783 30784.783 0 0 0 1.8 3.876C.808 1.855 0 .062 0 0h6.642Q13.2 13.15 19.751 26.311C24.477 16.839 28.808 7.979 32.736 0h6.5C32.238 14.415 27.43 24.259 20.9 37.451L19.637 40z",
    style: {
      fill: "#ff9100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.4.1h18.1c0 .085-8.942 18.077-8.985 18.077C110.536 12.052 106.94 5.574 104.4.1z",
    transform: "translate(-93.843 -.089)",
    style: {
      fill: "#6a6865"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeevaModule);
export default __webpack_public_path__ + "static/media/VeevaModule.0202dbac16d51fc2fdf1de2b1108bae9.svg";
export { ForwardRef as ReactComponent };